// @file footerNavigation.js

require('velocity-animate');

const $body = $(document.body);
const $site = $('.site', $body);
const $diagramSection = $('.team-diagrams-accordions', $site);

$('.js_teams-diagrams-nav-header').on('click', function () {
  const $self = $(this);
  mobileTeamDiagramAction($self);
});

function mobileTeamDiagramAction(target) {
  const navigationGroupAll = $('.js_teams-diagrams-nav-group', $diagramSection);
  const navigationGroupRoot = target.parent();
  const navigationGroupQuotes = target.parent().next();
  const navigationGroupContent = target.next();

  if ( navigationGroupRoot.hasClass('is_open') ) {
    navigationGroupRoot.removeClass('is_open');
    navigationGroupQuotes.velocity('slideUp', {duration: 200});
    navigationGroupContent.velocity('slideUp', {duration: 200});
  } else {
    navigationGroupAll.removeClass('is_open');
    // Dropdown functionally works without this 
    // navigationGroupAll.find('.js_teams-diagrams-nav-content').hide();
    navigationGroupRoot.addClass('is_open');
    navigationGroupQuotes.velocity('slideDown', {duration: 200, display: 'flex'});
    navigationGroupContent.velocity('slideDown', {duration: 200, display: 'block'});
  }
}
